var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64.272,
    viewBox: "0 0 64 64.272",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_999",
    "data-name": "Ellipse 999",
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#ffe2cf"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6982",
    "data-name": "Group 6982",
    transform: "translate(-3523 -1062.834)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_998",
    "data-name": "Ellipse 998",
    cx: 32,
    cy: 32,
    r: 32,
    transform: "translate(3523 1063.107)",
    fill: "#ffe2cf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_7",
    "data-name": "Mask Group 7",
    transform: "translate(3523 1062.834)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6509",
    "data-name": "Group 6509",
    transform: "translate(10.981 5.093)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15776",
    "data-name": "Path 15776",
    d: "M69.526,59.4V57.619a5.045,5.045,0,1,0-10.09,0v1.763Z",
    transform: "translate(-43.325 -52.574)",
    fill: "#002f5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15777",
    "data-name": "Path 15777",
    d: "M72.33,86.463l-3.3,48.216H57.18l-.41-48.884Z",
    transform: "translate(-43.878 -45.679)",
    fill: "#002f5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15778",
    "data-name": "Path 15778",
    d: "M62.117,132.784l1.292-38",
    transform: "translate(-42.768 -43.814)",
    fill: "none",
    stroke: "#2d4574",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15779",
    "data-name": "Path 15779",
    d: "M62.809,91.73h.243a1.329,1.329,0,0,0,1.337-1.337V87.947h-1.58Z",
    transform: "translate(-42.625 -45.232)",
    fill: "none",
    stroke: "#2d4574",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15780",
    "data-name": "Path 15780",
    d: "M55.753,90.091a2.811,2.811,0,0,0,2.826,2.781H71.3a2.714,2.714,0,0,0,1.4-.38,2.748,2.748,0,0,0,1.352-2.143l-.2-21.836a15.665,15.665,0,0,0-6.169-3.419H63c-.957,0-6.99,2.37-8.585,4.726Z",
    transform: "translate(-44.367 -49.975)",
    fill: "#4666a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15781",
    "data-name": "Path 15781",
    d: "M68.8,77.276l2.249,9.193L71,79.251Z",
    transform: "translate(-41.382 -47.447)",
    fill: "#1054b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15782",
    "data-name": "Path 15782",
    d: "M63.35,66.328v26.3",
    transform: "translate(-42.512 -49.719)",
    fill: "none",
    stroke: "#002f5e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15783",
    "data-name": "Path 15783",
    d: "M62.566,69.731a.274.274,0,1,1,.274-.274A.274.274,0,0,1,62.566,69.731Z",
    transform: "translate(-42.732 -49.126)",
    fill: "none",
    stroke: "#002f5e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15784",
    "data-name": "Path 15784",
    d: "M62.566,72.94a.274.274,0,1,1,.274-.274A.274.274,0,0,1,62.566,72.94Z",
    transform: "translate(-42.732 -48.46)",
    fill: "none",
    stroke: "#002f5e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15785",
    "data-name": "Path 15785",
    d: "M62.566,76.162a.274.274,0,1,1,.274-.273A.273.273,0,0,1,62.566,76.162Z",
    transform: "translate(-42.732 -47.791)",
    fill: "none",
    stroke: "#002f5e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15786",
    "data-name": "Path 15786",
    d: "M62.566,79.37a.274.274,0,1,1,.274-.274A.273.273,0,0,1,62.566,79.37Z",
    transform: "translate(-42.732 -47.125)",
    fill: "none",
    stroke: "#002f5e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15787",
    "data-name": "Path 15787",
    d: "M62.566,82.592a.274.274,0,1,1,.274-.274A.274.274,0,0,1,62.566,82.592Z",
    transform: "translate(-42.732 -46.457)",
    fill: "none",
    stroke: "#002f5e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15788",
    "data-name": "Path 15788",
    d: "M62.566,85.813a.274.274,0,1,1,.274-.274A.274.274,0,0,1,62.566,85.813Z",
    transform: "translate(-42.732 -45.788)",
    fill: "none",
    stroke: "#002f5e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15789",
    "data-name": "Path 15789",
    d: "M50.892,84.083H68.975v12H50.892Z",
    transform: "translate(-45.098 -46.034)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15790",
    "data-name": "Path 15790",
    d: "M59.116,92.964l-4.179.091-1.2-1.687,3.237-1.535s.988,1.064,1.489,1.489a9.993,9.993,0,0,0,2.994.653S61.273,93.132,59.116,92.964Z",
    transform: "translate(-44.508 -44.84)",
    fill: "#df935f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15791",
    "data-name": "Path 15791",
    d: "M58.909,92.583l.79.988a1.569,1.569,0,0,0,.79.517l1.52.41a.573.573,0,0,1-.2,1.124s-2.036-.152-2.7-.274A6.359,6.359,0,0,1,54.73,92.69l3.632-1.018Z",
    transform: "translate(-44.301 -44.459)",
    fill: "#df935f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15792",
    "data-name": "Path 15792",
    d: "M46.9,85.015l7.7,11.837.486.745,5.47-3.5-.349-.714L54.745,82.28l7.841-8.874-6.245-4.574L47.375,79A4.918,4.918,0,0,0,46.9,85.015Z",
    transform: "translate(-46.094 -49.199)",
    fill: "#4666a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15793",
    "data-name": "Path 15793",
    d: "M61.5,58.714v7.7l2.234,1.489L66.2,66.418v-7.7Z",
    transform: "translate(-42.896 -51.299)",
    fill: "#df935f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15794",
    "data-name": "Path 15794",
    d: "M61.513,62.132a4.848,4.848,0,0,0,4.68,1.337V60.992c-.866.015-1.58.076-1.58.076Z",
    transform: "translate(-42.894 -50.826)",
    fill: "#b6662d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15795",
    "data-name": "Path 15795",
    d: "M64.462,64.209A4.711,4.711,0,1,1,69.172,59.5,4.711,4.711,0,0,1,64.462,64.209Z",
    transform: "translate(-43.259 -52.114)",
    fill: "#df935f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15796",
    "data-name": "Path 15796",
    d: "M68.62,59.515l.426-.957s-.167-.805-.881-3.92C68.179,54.637,64.927,57.813,68.62,59.515Zm-8.342,0-.425-.957s.167-.805.881-3.92C60.733,54.637,63.97,57.813,60.277,59.515Z",
    transform: "translate(-43.238 -52.145)",
    fill: "#df935f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15797",
    "data-name": "Path 15797",
    d: "M60.14,59.391a1.2,1.2,0,1,1,1.307-1.2A1.257,1.257,0,0,1,60.14,59.391Z",
    transform: "translate(-43.45 -51.657)",
    fill: "#df935f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15798",
    "data-name": "Path 15798",
    d: "M60.064,57.33a.823.823,0,0,0-.866.79.735.735,0,0,0,.243.547",
    transform: "translate(-43.374 -51.586)",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15799",
    "data-name": "Path 15799",
    d: "M67.64,59.391a1.2,1.2,0,1,1,1.307-1.2A1.257,1.257,0,0,1,67.64,59.391Z",
    transform: "translate(-41.893 -51.657)",
    fill: "#df935f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15800",
    "data-name": "Path 15800",
    d: "M67.415,57.33a.823.823,0,0,1,.866.79.735.735,0,0,1-.243.547",
    transform: "translate(-41.669 -51.586)",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15801",
    "data-name": "Path 15801",
    d: "M67.56,55.883l.456-1.155a13.829,13.829,0,0,0-7.446,0l.9,2.021C61.481,56.749,67.073,57.2,67.56,55.883Z",
    transform: "translate(-43.089 -52.236)",
    fill: "#df935f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15802",
    "data-name": "Path 15802",
    d: "M65.812,64.314,63.35,66.745l1.687,1.5,1.17-2.9Z",
    transform: "translate(-42.512 -50.137)",
    fill: "#002f5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15803",
    "data-name": "Path 15803",
    d: "M63.826,66.743l-2.219-2.416L61.06,65.36l1.064,3.024Z",
    transform: "translate(-42.988 -50.134)",
    fill: "#002f5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15804",
    "data-name": "Path 15804",
    d: "M60.595,73.664H56.857",
    transform: "translate(-43.86 -48.196)",
    fill: "none",
    stroke: "#002f5e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15805",
    "data-name": "Path 15805",
    d: "M53.145,92.634l.471.729,5.47-3.495-.349-.714Z",
    transform: "translate(-44.63 -44.981)",
    fill: "#1054b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15806",
    "data-name": "Path 15806",
    d: "M53.246,80.907l1.915-5.531.213,3.115Z",
    transform: "translate(-44.61 -47.841)",
    fill: "#1054b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15807",
    "data-name": "Path 15807",
    d: "M67.084,91.775l4.179.091,1.2-1.687-3.237-1.535s-.988,1.064-1.489,1.489a9.993,9.993,0,0,1-2.994.653S64.926,91.942,67.084,91.775Z",
    transform: "translate(-42.223 -45.087)",
    fill: "#df935f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15808",
    "data-name": "Path 15808",
    d: "M67.288,91.394l-.79.988a1.57,1.57,0,0,1-.79.517l-1.52.41a.573.573,0,0,0,.2,1.124s2.036-.152,2.7-.274A6.359,6.359,0,0,0,71.466,91.5l-3.632-1.018Z",
    transform: "translate(-42.427 -44.706)",
    fill: "#df935f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15809",
    "data-name": "Path 15809",
    d: "M80.8,83.825,73.1,95.663l-.486.745-5.47-3.5.349-.714,5.47-11.108-7.841-8.874,6.245-4.574,8.965,10.166A4.918,4.918,0,0,1,80.8,83.825Z",
    transform: "translate(-42.145 -49.446)",
    fill: "#4666a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15810",
    "data-name": "Path 15810",
    d: "M72.749,91.445l-.471.729-5.47-3.5.349-.714Z",
    transform: "translate(-41.795 -45.228)",
    fill: "#1054b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15811",
    "data-name": "Path 15811",
    d: "M71.993,79.717l-1.915-5.531L69.865,77.3Z",
    transform: "translate(-41.16 -48.088)",
    fill: "#1054b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15812",
    "data-name": "Path 15812",
    d: "M68.3,55.238s-2.857,1.93-7.78.745l-.471,1.747.122-2.842,3.89-1.459,4.118,1.428Z",
    transform: "translate(-43.197 -52.396)",
    fill: "#002f5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15813",
    "data-name": "Path 15813",
    d: "M64.4,60.649a1.458,1.458,0,0,1-1.656-.638",
    transform: "translate(-42.638 -51.03)",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/Icon4.5c7cc246c6e2defe0e2199a298fd5d83.svg";
export { ForwardRef as ReactComponent };